angular.module('am4')
.filter('formatTableCell', function() {
    return function(input) {
        if (input) {
            return input;
        }
        return '—';
    };
});



// WEBPACK FOOTER //
// ./src/app/filters/formatTableCell.js